import { Alert, Button, Spin, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';

class FileUpload extends React.Component {
  static propTypes = {
    includeMarginTop: PropTypes.bool.isRequired,
    next: PropTypes.func,
    onRemove: PropTypes.func,
    postNewFile: PropTypes.func.isRequired,
    setFile: PropTypes.func,
    skippable: PropTypes.bool,
    toggleShowModal: PropTypes.func,
  };

  static defaultProps = {
    next: null,
    onRemove: null,
    setFile: null,
    skippable: false,
    toggleShowModal: null,
  };

  state = {
    file: null,
    loading: false,
  };

  /**
   * Called whenever the uploaded file changes.
   */
  beforeUpload = file => {
    const { setFile } = this.props;
    this.setState({
      file,
    });
    setFile(file);
  };

  /**
   * Called whenever the user clicks the "Skip" button.
   * Will move the user to the next step of the modal.
   */
  skipClicked = () => {
    const { next } = this.props;
    next('skip');
  };

  /**
   * Called whenever the user clicks the "OK" button.
   * Will move to the next step unless there is no next
   * step, i.e if the step is not skippable.
   */
  okClicked = async () => {
    const { next, postNewFile, skippable, toggleShowModal } = this.props;
    const { file } = this.state;

    if (skippable) {
      next();
    } else {
      this.setState({ loading: true });
      await postNewFile(file);
      this.setState({ loading: false });
      if (toggleShowModal) toggleShowModal();
    }
  };

  render() {
    const { includeMarginTop, onRemove, skippable } = this.props;
    const { file, loading } = this.state;

    const pMarginTop = includeMarginTop ? 20 : 0;
    return (
      <Spin spinning={loading}>
        <div style={{ textAlign: 'left' }}>
          <p style={{ marginTop: pMarginTop }}>
            Choose a file to upload which you would like to map to a FHIR resource or resources.
          </p>
          <Alert message="Do not upload any PHI or any sensitive data" type="error" />
          <Upload
            customRequest={() => {}}
            listType="picture"
            progress={{ strokeWidth: 2, showInfo: false, percent: 100 }}
            onRemove={onRemove}
            onChange={this.onChange}
            beforeUpload={this.beforeUpload}
            spinning={false}
          >
            <Button style={{ marginTop: 10 }} icon={<UploadOutlined />}>
              Select New File
            </Button>
          </Upload>
          <Button
            style={{ marginTop: 10 }}
            disabled={file === null}
            type="primary"
            onClick={() => this.okClicked()}
          >
            OK
          </Button>
        </div>
        {skippable && (
          <Button type="primary" onClick={() => this.skipClicked()} style={{ marginLeft: '90%' }}>
            Skip
          </Button>
        )}
      </Spin>
    );
  }
}

export default FileUpload;
